import React, { PropTypes} from 'react';

import Card from './Card';
import CardBlock from './CardBlock';

const Container = ({ children, className, title }) => {
    return (
        <div className={className}>
            <div>
                <h3>{title}</h3>
                <Card>
                    {children}
                </Card>
            </div>
        </div>
    );
};

Container.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    title: PropTypes.string.isRequired
};

export default Container;


/** WEBPACK FOOTER **
 ** ./src/components/bootstrap/Container.js
 **/